import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { INHERITED_CLASS } from '@angular/core/src/reflection/reflection_capabilities';

@Injectable({
  providedIn: 'root'
})
export class ScService {
  //検索条件
  init_sc = {
    conditions: 'and',

    sales_contact_code: '',
    division_code: '',

    customer_no: '',
    contract_no: '',
    customer_name: '',
    kana_name: '',
    sel_year: '',
    sel_month: '',
    sel_day: '',
    age_from: '',
    age_to: '',
    gender: '',
    zip_code: '',
    pref: '',
    city: '',
    address: '',
    tel_number: '',
    fax_number: '',
    mobile_number: '',
    mail_address: '',
    family_name1: '',
    family_relation1: '',
    family_bitrh1: '',
    family_name2: '',
    family_relation2: '',
    family_bitrh2: '',
    family_name3: '',
    family_relation3: '',
    family_bitrh3: '',
    family_name4: '',
    family_relation4: '',
    family_bitrh4: '',
    family_name5: '',
    family_relation5: '',
    family_bitrh5: '',
    note: '',

    family_structure: "",
    parent_num: "",
    children: "",
    children_num: "",
    income: "",
    car: "",
    q_land: "",
    a1: {},
    a1_introducer: "",
    a1_other: "",
    a2_1: "",
    a2_2: "",
    a2_3: "",
    a2_1_memo: "",
    a2_2_memo: "",
    a2_3_memo: "",
    a2_1_introduced: "",
    a2_2_introduced: "",
    a2_3_introduced: "",
    a3: {},
    a3_other: "",
    a4: "",
    a4_memo: "",
    a5: "",
    a5_other: "",
    a6: "",
    a7: "",
    a7_other: "",
    a7_reason: "",
    a8: {},
    a8_other: "",

    status: {},
    rank: {},
    rank_ob: {},

    first_contanct_datetime: '',

    total_points: '',
    land_points: '',
    capital_points: '',
    plan_points: '',
    conflict_points: '',
    affected_points: '',
    time_points: '',
    visit_points: '',
    opertor_points: '',
    app_poins: '',
    first_contanct_datetime1: '',
    first_contanct_datetime2: '',
    temporary_reception_date1: '',
    temporary_reception_date2: '',
    temporary_approval_date1: '',
    temporary_approval_date2: '',
    closing_schedule_date1: '',
    closing_schedule_date2: '',
    contract_schedule_date1: '',
    contract_schedule_date2: '',
    land_contract_target_date1: '',
    land_contract_target_date2: '',
    land_contract_result_date1: '',
    land_contract_result_date2: '',
    land_settlement_target_date1: '',
    land_settlement_target_date2: '',
    land_settlement_result_date1: '',
    land_settlement_result_date2: '',
    loan_temporary_app_target1: '',
    loan_temporary_app_target2: '',
    loan_temporary_app_actual1: '',
    loan_temporary_app_actual2: '',
    finance_temporary_app_target1: '',
    finance_temporary_app_target2: '',
    finance_temporary_app_actual1: '',
    finance_temporary_app_actual2: '',
    finance_application_target_date1: '',
    finance_application_target_date2: '',
    finance_app_target_date1: '',
    finance_app_target_date2: '',
    finance_app_actual_date1: '',
    finance_app_actual_date2: '',
    bridge_loan_land1: '',
    bridge_loan_land2: '',
    bridge_loan_const1: '',
    bridge_loan_const2: '',
    bridge_loan_interim1: '',
    bridge_loan_interim2: '',
    money_consumpltion_agree1: '',
    money_consumpltion_agree2: '',
    ground_survey_request_date1: '',
    ground_survey_request_date2: '',
    ground_survey_implement_date1: '',
    ground_survey_implement_date2: '',
    dismantling_start_date1: '',
    dismantling_start_date2: '',
    dismantling_end_date1: '',
    dismantling_end_date2: '',
    garden_start_date1: '',
    garden_start_date2: '',
    garden_end_date1: '',
    garden_end_date2: '',
    ground_improvement_date1: '',
    ground_improvement_date2: '',
    approval_book_get_date1: '',
    approval_book_get_date2: '',
    four_people_meeting1: '',
    four_people_meeting2: '',
    final_decision_mark1: '',
    final_decision_mark2: '',
    other_resuest_date1: '',
    other_resuest_date2: '',
    other_resuest_approval_date1: '',
    other_resuest_approval_date2: '',
    confirm_resuest_date1: '',
    confirm_resuest_date2: '',
    confirm_resuest_approval_date1: '',
    confirm_resuest_approval_date2: '',
    construction_approval_date1: '',
    construction_approval_date2: '',
    construction_payment_date1: '',
    construction_payment_date2: '',
    gl_layout1: '',
    gl_layout2: '',
    ground_prayer1: '',
    ground_prayer2: '',
    base_construction_date1: '',
    base_construction_date2: '',
    midway_payment_date1: '',
    midway_payment_date2: '',
    upper_build_date1: '',
    upper_build_date2: '',
    outlet1: '',
    outlet2: '',
    midway_check_date1: '',
    midway_check_date2: '',
    framework_end_date1: '',
    framework_end_date2: '',
    company_inspection_date1: '',
    company_inspection_date2: '',
    complete_check_date1: '',
    complete_check_date2: '',
    completion_date1: '',
    completion_date2: '',
    final_payment_date1: '',
    final_payment_date2: '',
    furniture_carryout_start_date1: '',
    furniture_carryout_start_date2: '',
    furniture_carryout_end_date1: '',
    furniture_carryout_end_date2: '',
    complete_visit_start_date1: '',
    complete_visit_start_date2: '',
    complete_visit_end_date1: '',
    complete_visit_end_date2: '',
    delivery_date1: '',
    delivery_date2: '',
    iv_datetime_from: '',
    iv_datetime_to: '',
    iv_title: '',
  }

  sc = Object.assign({}, this.init_sc);
  constructor(
    private http: HttpClient,
  ) { }

}
